import { HeadingOneText } from '@mint/ui';
import styled from 'styled-components';

export const AdminPanelHeadingText = styled(HeadingOneText)`
  :first-child {
    margin-top: 0.5rem;
  }
`;
